import {customElement, bindable} from "aurelia-framework";
import {AbstractCell} from './abstract-cell';

import './file-path.less';

@customElement('sio-cell-file-path')
export class FilePath extends AbstractCell
{
    @bindable column;
    @bindable item;

    itemChanged()
    {
        this.bind();
    }
}
